import { DatasetElementType } from '@mui/x-charts/internals';
import _ from 'lodash';
import { useDuckQuery } from '../../../../../duckDB/hooks/useDuckQuery';
import { formatStringList } from '../../../../../duckDB/utils/formatStringList';
import { formattedDateColumn } from '../../../../../duckDB/utils/formattedDateColumn';
import { SizeReportData } from '../../../../components/ReportBarChart/types';
import { SizeBucket } from '../SizeBucket';

export const useSizeReportChartData = (
  scanDate: string,
  ranchIds: string[],
  isTableLoading: boolean
): {
  data: DatasetElementType<string | number>[];
  yAxisValueFormatter: (value: string) => string;
  sizeBuckets: SizeBucket[];
  loading: boolean;
} => {
  const { data: chartData, isLoading } = useDuckQuery<SizeReportData>(
    `
    SELECT 
    CONCAT(block_name, '|', block_id) as dataKey,
    ranch_id as ranchId,
    block_id as blockId, 
    block_name as blockName, 
    scan_id as scanId,
    ${formattedDateColumn('scan_date')} AS scanDate,
    size_deduplicated_counts AS sizeEstimatedCounts,
    list_sum(
      list_transform(json_keys(size_deduplicated_counts), 
      k -> json_extract(size_deduplicated_counts,k)::FLOAT)) as totalCount,
    FROM size_report_table WHERE scan_date='${scanDate}'
    AND ranch_id IN ${formatStringList(ranchIds)}
    ORDER BY block_name ASC
    `
  );

  return {
    ...formatSizeReportChartData(chartData),
    loading: isTableLoading || isLoading,
  };
};

const formatSizeReportChartData = (data: SizeReportData[] | null) => {
  if (!data) {
    return {
      data: [],
      yAxisValueFormatter: () => '',
      sizeBuckets: [],
    };
  }

  const sizeBuckets = new Set<string>();

  const formattedData = data.map((item) => {
    const sizeCounts = JSON.parse(item.sizeEstimatedCounts);
    const sizes = Object.keys(sizeCounts);
    return Object.assign(
      {
        ...item,
        totalCount: _.sum(Object.values(sizeCounts)),
      },
      ...sizes.map((sizeBucket) => {
        sizeBuckets.add(sizeBucket);
        return {
          [sizeBucket]: Math.round(sizeCounts[sizeBucket]) || 0,
        };
      })
    );
  });

  return {
    data: formattedData,
    yAxisValueFormatter: (value: string) => value.split('|', 1).at(0) || '',
    sizeBuckets: Array.from(sizeBuckets),
  };
};
